import React from "react";
import Styles from "./index.module.scss";
import { NotEndAxios } from "../../../../../../../service/score";
import { Button, Empty } from "antd";
import { isEmpty } from "lodash-es";

interface Props {
    data: NotEndAxios[] | undefined;
    overAll: () => void;
    overOne: (value: NotEndAxios) => void;
}
const Index = ({ data, overAll, overOne }: Props) => {
    return (
        <ul className={Styles.root}>
            {data && data?.length > 0 && (
                <Button onClick={overAll} className={Styles.btn}>
                    一键完结此类目下所有项
                </Button>
            )}
            {data?.map(item => (
                <li className={Styles.li} key={`${item.type}-${item.id}`}>
                    <span>{item.title}</span>
                    <span>
                        <Button type="link" onClick={() => overOne(item)}>
                            完结此项
                        </Button>
                    </span>
                </li>
            ))}
            {isEmpty(data) && <Empty description="恭喜！暂无未完成的项目" />}
        </ul>
    );
};

export default Index;
